<!--
 - Override popover component HTML
 -
 - @version
 - 4.71.0 OAUI-694 Final UI tweaks and finishing touches
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2024 Build Centrix
 -->
<div class="order-override-popover">
  <!--Original Value-->
  <div class="text-value">
    <bc-atoms-input-group
      labelIcon="jobsAdmin"
      labelTitle="{{'order.list.job.' + type + '.title'|translate}}"
      labelDescription="{{'order.list.job.' + type + '.description'|translate}}"
    >
      <div class="item">{{order.job[type]}}</div>
    </bc-atoms-input-group>
  </div>

  <!--Override Value-->
  <div class="input-value">
    <bc-atoms-input-group
      labelIcon="adjustment"
      labelTitle="{{'order.list.job.' + type + '.override.title'|translate}}"
      labelDescription="{{'order.list.job.' + type + '.override.description'|translate}}"
    >
      <div class="item">
        <bc-atoms-input
          id="jobOverride{{type}}_{{order.number}}"
          name="jobOverride{{type}}_{{order.number}}"
          title="{{'order.list.job.' + type + '.override.title'|translate}}"
          placeholder="{{'order.list.job.' + type + '.override.description'|translate}}"
          [disabled]="order.job?.override['isUpdating' + label]"
          [(model)]="order.job.override[type + 'Edit']"
        ></bc-atoms-input>
      </div>
    </bc-atoms-input-group>
  </div>

  <hr />

  <div class="button-options">
    <div class="button">
      <!--Cancel-->
      <bc-atoms-button
        label="{{'actions.cancel'|translate}}"
        title="{{'actions.cancel'|translate}}"
        icon="cancel"
        size="small"
        display="block"
        [disabled]="order.job?.override['isUpdating' + label]"
        (onButtonClicked)="togglePopoverClosed(popover)"
      >
      </bc-atoms-button>
    </div>
    <div class="button">
      <!--Save-->
      <bc-atoms-button
        label="{{'actions.save'|translate}}"
        title="{{'actions.save'|translate}}"
        icon="save"
        display="block"
        size="small"
        type="success"
        [loading]="order.job?.override['isUpdating' + label]"
        [disabled]="order.job.override[type] === order.job.override[type + 'Edit']"
        (onButtonClicked)="updateOrderJobOverride(order, popover, type, label)"
      >
      </bc-atoms-button>
    </div>
  </div>
</div>
